function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import cn from 'classnames';
import { Typography, Button } from 'seagull';
import { KycCompletionStatus } from "../../../store/store.model";
import styles from "./BusinessOnboardingWidget.module.scss";
export const Box = _ref => {
  let {
    children,
    className
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.box, className)
  }, children);
};
export const StepTitle = _ref2 => {
  let {
    children,
    spacing = 'normal'
  } = _ref2;
  return /*#__PURE__*/React.createElement(Typography, {
    className: styles[spacing + 'Spacing'],
    weight: "normal",
    variant: "h6"
  }, children);
};
export const StepSubtitle = _ref3 => {
  let {
    children,
    spacing = 'normal'
  } = _ref3;
  return /*#__PURE__*/React.createElement(Typography, {
    className: styles[spacing + 'Spacing'],
    variant: "paragraph1"
  }, children);
};
export const StepHelperText = _ref4 => {
  let {
    children,
    spacing = 'normal'
  } = _ref4;
  return /*#__PURE__*/React.createElement(Typography, {
    className: styles[spacing + 'Spacing'],
    variant: "paragraph2",
    skin: "secondary"
  }, children);
};
export const ActionButton = props => {
  return /*#__PURE__*/React.createElement(Button, _extends({
    size: "medium"
  }, props));
};
export function StepLayout(props) {
  const {
    id,
    title,
    subtitle,
    actions,
    icon
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.stepLayout,
    "data-testid": "onboarding-widget-content-".concat(id)
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StepTitle, null, title), /*#__PURE__*/React.createElement(StepSubtitle, null, subtitle)), /*#__PURE__*/React.createElement("div", {
    className: styles.actions
  }, actions)), /*#__PURE__*/React.createElement("div", null, icon));
}
export function getKycWarning(worksAt) {
  const {
    kycCompletionStatus
  } = worksAt || {};

  if (kycCompletionStatus === KycCompletionStatus.CompletedWithFutureRequirements) {
    return {
      testid: 'kyc-future-requirements',
      text: 'To avoid an interruption in charges and payouts, additional information is required'
    };
  } else if (kycCompletionStatus === KycCompletionStatus.Incomplete) {
    return {
      testid: 'onboarding-kyc-error',
      text: 'Additional information is required to verify your business identity and enable payouts'
    };
  } else {
    return null;
  }
}